import { licenseIsInfinite, renderLicenseCredits } from "./LicenceCredits";
import { LicenseStatus } from "../../redux/actions/licenses/licenceTypes";
import { unlinkLicenseUser } from "../../redux/actions/licenses/licenseListAsyncActions";
import { ThunkDispatch } from "redux-thunk";
import { GridDeleteIcon } from "@mui/x-data-grid-pro";
import { Add } from "@mui/icons-material";
import { TFunction } from "i18next";
import { Button, Link } from "@mui/material";
import {
  focusedLicense,
  LicensesFilters,
  setPreselectedFilterField,
  setShowFilterForm,
} from "../../redux/slices/licenses/licenseList";
import { useDispatch, useSelector } from "react-redux";
import { getOperatorsFromAvailableFilters } from "../helpers/helpersSearchs";
import CustomGeneralColumnHeader from "../customFilterComponent/customHeader";

const useSetActions = () => {
  const dispatch = useDispatch();
  return {
    onOpenFilter: (field: string) => {
      dispatch(setShowFilterForm(true));
      dispatch(setPreselectedFilterField(field));
    },
  };
};

export const useLicenseColumns = (
  t: TFunction,
  dispatch: ThunkDispatch<any, any, any>,
) => {
  const { onOpenFilter } = useSetActions();
  const { filterModel } = useSelector(LicensesFilters);

  let licenseColumns: any[] = [
    {
      field: "username",
      headerName: t("Data.table.Username"),
      disableColumnMenu: true,
      width: 300,
      sortable: true,
      type: "string",
      filterOperators: getOperatorsFromAvailableFilters([
        "$ilike",
        "$eq",
        "$ne",
      ]),
      filter: "LOCAL",
      service: "text",
      renderHeader: () => (
        <CustomGeneralColumnHeader
          headerName={t("Data.table.Username")}
          field={"username"}
          filterModel={filterModel}
          availableFilters={["$ilike", "$eq", "$ne"]}
          onOpenFilter={onOpenFilter}
          backgroundColor="#fafafa"
        />
      ),
      renderCell(params) {
        return params.value ? <>{params.value}</> : <Link href={"/users"} />;
      },
    },
    {
      field: "siteName",
      headerName: t("Dashboard.activityTable.site"),
      disableColumnMenu: true,
      width: 300,
      sortable: false,
      type: "string",
      filterOperators: getOperatorsFromAvailableFilters([
        "$ilike",
        "$eq",
        "$ne",
      ]),
      filter: "LOCAL",
      service: "text",
      renderHeader: () => (
        <CustomGeneralColumnHeader
          headerName={t("Dashboard.activityTable.site")}
          field={"siteName"}
          filterModel={filterModel}
          availableFilters={["$ilike", "$eq", "$ne"]}
          onOpenFilter={onOpenFilter}
          backgroundColor="#fafafa"
        />
      ),
      renderCell(params) {
        return <>{params.value}</>;
      },
    },
    {
      field: "balance",
      headerName: t("Users_tables.columns_table_one.balance"),
      disableColumnMenu: true,
      width: 200,
      sortable: true,
      type: "string",
      renderCell(params) {
        return renderLicenseCredits(
          [params.row],
          t("licenses.addLicense"),
          t("licenses.expired"),
        );
      },
    },
    {
      field: "expiryDate",
      headerName: t("licenses.expiration"),
      disableColumnMenu: true,
      width: 200,
      sortable: true,
      type: "string",
      renderCell(params) {
        return <>{new Date(params.value).toLocaleDateString()}</>;
      },
    },
    {
      field: "id",
      headerName: t("licenses.unlinkUser"),
      disableColumnMenu: true,
      width: 150,
      sortable: false,
      renderCell(params) {
        return (
          <Button
            disabled={params.row.statusConstantId > LicenseStatus.assigned}
            color="error"
            onClick={() => dispatch(unlinkLicenseUser(params.value))}
          >
            <GridDeleteIcon />
          </Button>
        );
      },
    },
    {
      field: "",
      headerName: t("licenses.addPack"),
      disableColumnMenu: true,
      width: 150,
      sortable: false,
      renderCell(params) {
        return licenseIsInfinite(params.row) ||
          !(params.row as any).hasPacks ? null : (
          <Button
            color="info"
            onClick={() => dispatch(focusedLicense(params.row.id))}
          >
            <Add />
          </Button>
        );
      },
    },
  ];

  return { licenseColumns };
};
